export type BookingArtwork = {
  vectorUrl?: string | null;
  previewUrl?: string | null;
  largeUrl?: string | null;
  cardUrl?: string | null;
};

/** Render only the published media URLs supplied by the API, never inline SVG. */
export function bookingArtworkUrl(
  image?: BookingArtwork | null,
): string | null {
  return (
    [image?.vectorUrl, image?.previewUrl, image?.largeUrl, image?.cardUrl].find(
      (value): value is string =>
        Boolean(
          value &&
          /^(https?:\/\/|\/(?!\/)|data:image\/(?:webp|png|jpeg|svg\+xml)[;,])/i.test(
            value,
          ),
        ),
    ) ?? null
  );
}

type CityArtworkSource = {
  publicIdentity?: {
    kind: "place" | "city";
    id: string;
    name: string;
    image?: BookingArtwork | null;
  } | null;
  publicCity?: { image?: BookingArtwork | null } | null;
};

/** A visitor's venue choice must not replace the server-resolved CityDay identity. */
export function cityDayArtworkUrl(day: CityArtworkSource): string | null {
  return bookingArtworkUrl(
    "publicIdentity" in day ? day.publicIdentity?.image : day.publicCity?.image,
  );
}

/** Remove a failed decorative image without leaving a blank artwork column. */
export function installArtworkFailureFallback(root: HTMLElement): void {
  root.addEventListener(
    "error",
    (event) => {
      const image = event.target;
      if (!(image instanceof HTMLImageElement)) return;
      if (image.closest(".meeting-summary-media")) {
        image.closest(".meeting-summary")?.classList.add("without-artwork");
        image.remove();
      } else if (image.classList.contains("city-day-artwork")) {
        image
          .closest(".city-day-type-card")
          ?.classList.remove("has-city-artwork");
        image.remove();
      } else if (image.classList.contains("city-day-hero-artwork")) {
        image
          .closest(".city-day-hero")
          ?.classList.remove("has-identity-artwork");
        image.remove();
      }
    },
    true,
  );
}
